import { call, put, takeEvery } from 'redux-saga/es/effects';
import { select } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios/index';
import _ from "../shared/utils/ObjectUtils";
import WidgetUtils from './utils/WidgetUtils';
import { chartConfigsSagas } from './widgetsSagas/chart/sagas';
import { controllerSagas } from './widgetsSagas/controller/sagas';
import { getUserPageRefresh } from '../auth/sagas';
import actions from '../auth/actions';

const controllerUrl = '/dashboard/';

const mockTree = {
    depth: 6,
    checked: [
        "0a004b01-5fc4-1b18-815f-c49c502d0013"
    ],
    expanded: [
        "0a004b01-5fc4-1b18-815f-c49c502d0013",
        "0a200117-6009-1175-8160-1c1ce25808af"
    ],
    tree: {
        dashboardId: 27,
        disabled: false,
        value: "0a004b01-5fc4-1b18-815f-c49c502d0013",
        label: "InnLink Admin",
        type: "ROOT",
        children: [
            {
                dashboardId: "0a000274-6668-1302-8166-68d758c30006",
                disabled: false,
                label: "Caldas Enterprise",
                type: "ENTERPRISE",
                value: "0a200117-6009-1175-8160-1c1ce25808af",
                children: [{
                    children: [],
                    dashboardId: "0a000274-6668-1302-8166-68d758c90007",
                    disabled: false,
                    label: "Caldas Farm",
                    type: "FARM",
                    value: "0a200117-6009-1175-8160-1c1e039008bb"
                }]
            },{
                dashboardId: "0a000274-6668-1302-8166-68d75969000e",
                disabled: false,
                label: "enterprise fc demo",
                type: "ENTERPRISE",
                value: "0a20007b-623f-1075-8162-440a83410037",
                children: [
                    {
                        children: [],
                        dashboardId: "0a000274-6668-1302-8166-68d75bb6003e",
                        disabled: false,
                        label: "Demo Farmcontrol - Papelão",
                        type: "FARM",
                        value: "0a000205-65c4-18d8-8165-ec33eced0130"
                    },{
                        children: [],
                        dashboardId: "0a00051b-6b2d-19a2-816b-6507c90e017f",
                        disabled: false,
                        label: "Farm EFCD",
                        type: "FARM",
                        value: "0a00051b-6b2d-19a2-816b-6507c9140180"
                    }
                ]
            }
        ]
    }
};


const getHomepage = () => new Promise((resolve, reject) => {
    axios.get(controllerUrl + "homepage").then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const updateLayoutCall = (widgetsNewLayout, dashboardId) => new Promise((resolve, reject) => {
    axios.post(controllerUrl + dashboardId + "/updateLayout", widgetsNewLayout).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const fetchRealTimeWidgetData = (interfaceIds) => new Promise((resolve, reject) => {
    axios.get("/interfaces/lastReading?interfaceId=" + interfaceIds).then(
        response => resolve(response.data),
        error => reject(error)
    )
});

const createWidgetCall = (newWidget) => new Promise((resolve, reject) => {
    let formBox = new FormData();
    formBox.append('request', new Blob([JSON.stringify(newWidget)], {type: "application/json"}));

    axios.post("/widgets", formBox).then(
        response => resolve(response.data),
        error => reject(error)
    )
});

const editWidgetCall = (widgetId, widgetData) => new Promise((resolve, reject) => {
    let formBox = new FormData();
    formBox.append('request', new Blob([JSON.stringify(widgetData)], {type: "application/json"}));

    axios.put("/widgets/"+ widgetId, formBox).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const deleteWidgetCall = (widgetId) => new Promise((resolve, reject) => {
    axios.delete("/widgets/"+ widgetId ).then(
        response => resolve(response.data),
        error => reject(error)
    )
});

const duplicateWidgetCall = (widgetId) => new Promise((resolve, reject) => {
    axios.post("/widgets/"+ widgetId + "/duplicate").then(
        response => resolve(response.data),
        error => reject(error)
    )
});

const getDashboardEntitiesTreeCall = (rootEntityId) => new Promise((resolve, reject) => {
    setTimeout(
        () => resolve(mockTree),
        1000
    )
});

function* getDashboardWidgets() {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }

        const dashboard = yield call(getHomepage);
        dashboard.widgets = dashboard.widgets.map(widget => {
            widget.id = widget.id.toString();
            return widget;
        });

        const widgets = dashboard.widgets.reduce(
                (acc, widget) => ({
                    ...acc,
                    [widget.id]: widget
                }),
                {}
            );

        yield put({
            type: actionTypes.GET_DASHBOARD_INFO_SUCCESS,
            dashboard: dashboard,
            widgets: widgets,
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_DASHBOARD_INFO_FAILED
        });
    }
}

function* saveWidgetsNewPosition({ dashboardId, widgetsToUpdate }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        if(!_.isEmpty(widgetsToUpdate)){
            const widgetsNewLayout = {
                widgets: widgetsToUpdate.map(
                    widget => ({
                        widgetId: widget.i,
                        rowIndex: widget.y,
                        columnIndex: widget.x,
                        widgetWidth: widget.w,
                        widgetHeight: widget.h
                    })
                )
            };
            yield call(updateLayoutCall, widgetsNewLayout, dashboardId);
        }
    } catch (e) {
    }
}

function* fetchWidgetReadings({ interfaceIds }) {
    let interfaceIdsString = [...interfaceIds].join(',');

    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        if(interfaceIdsString.length === 0) {
            yield put({
                type: actionTypes.UPDATE_REAL_TIME_INTERFACES_DATA_SUCCESS,
                readings: []
            });
            return
        }
        const readingsArray = yield call(fetchRealTimeWidgetData, interfaceIdsString);
        yield put({
            type: actionTypes.UPDATE_REAL_TIME_INTERFACES_DATA_SUCCESS,
            readings: readingsArray
        });
    } catch (e) {
        yield put({
            type: actionTypes.UPDATE_REAL_TIME_INTERFACES_DATA_FAILED
        });
    }
}

function* createWidget({ widgetType, formData, dashboardId }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        let widgetToCreate = {};
        widgetToCreate.configs = {};

        widgetToCreate.dashboardId = dashboardId;
        widgetToCreate.type = widgetType;
        widgetToCreate.configs.widgetHeight = WidgetUtils.WidgetDefaultSize[widgetType].minH;
        widgetToCreate.configs.widgetWidth = WidgetUtils.WidgetDefaultSize[widgetType].minW;
        widgetToCreate.configs.rowIndex = 0;
        widgetToCreate.configs.columnIndex = 0;

        Object.keys(formData).forEach( configParameterKey => {
            widgetToCreate.configs[configParameterKey] = formData[configParameterKey].value;
        });

        const newWidget = yield call(createWidgetCall, widgetToCreate );

        newWidget.id = (newWidget.id).toString();

        yield put({
            type: actionTypes.CREATE_WIDGET_SUCCESS,
            newWidget: newWidget
        })
    } catch (e) {
        yield put({
            error: e,
            type: actionTypes.CREATE_WIDGET_FAILED
        });
    }
}

function* editWidget({widgetToEdit, formData}) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        Object.keys(formData).forEach( configParameterKey => {
            widgetToEdit.configs[configParameterKey] = formData[configParameterKey].value;
        });

        const widget = yield call(editWidgetCall, widgetToEdit.id, widgetToEdit);

        widget.id = (widget.id).toString();

        yield put({
            type: actionTypes.EDIT_WIDGET_SUCCESS,
            updatedWidget: widget
        })
    } catch (e) {
        yield put({
            error: e,
            type: actionTypes.EDIT_WIDGET_FAILED
        });
    }
}

function* deleteWidget({ widget }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        yield call(deleteWidgetCall, widget.id);

        yield put({
            type: actionTypes.DELETE_WIDGET_SUCCESS,
            widget: widget
        })
    } catch (e) {
        yield put({
            error: e,
            type: actionTypes.DELETE_WIDGET_FAILED
        });
    }
}

function* duplicateWidget({widgetId}) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const newWidget = yield call(duplicateWidgetCall, widgetId);

        newWidget.id = (newWidget.id).toString();

        yield put({
            type: actionTypes.DUPLICATE_WIDGET_SUCCESS,
            newWidget: newWidget
        })
    } catch (e) {
        yield put({
            error: e,
            type: actionTypes.DUPLICATE_WIDGET_FAILED
        });
    }
}

function* getDashboardEntitiesTree ({rootEntityId}) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const entitiesTree = yield call(getDashboardEntitiesTreeCall, rootEntityId);

        yield put({
            type: actionTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_SUCCESS,
            entitiesTree: entitiesTree
        })
    } catch (e) {
        yield put({
            error: e,
            type: actionTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_FAILED
        });
    }
}


const dashboardSagas = [
    takeEvery(actionTypes.GET_DASHBOARD_INFO_REQUEST, getDashboardWidgets),
    takeEvery(actionTypes.UPDATE_LAYOUT, saveWidgetsNewPosition),
    takeEvery(actionTypes.UPDATE_REAL_TIME_INTERFACES_DATA_REQUEST, fetchWidgetReadings),
    takeEvery(actionTypes.CREATE_WIDGET_REQUEST, createWidget),
    takeEvery(actionTypes.EDIT_WIDGET_REQUEST, editWidget),
    takeEvery(actionTypes.DELETE_WIDGET_REQUEST, deleteWidget),
    takeEvery(actionTypes.DUPLICATE_WIDGET_REQUEST, duplicateWidget),
    takeEvery(actionTypes.GET_DASHBOARD_DASHBOARD_ENTITIES_TREE_REQUEST, getDashboardEntitiesTree),
    ...chartConfigsSagas,
    ...controllerSagas
];

export {
    dashboardSagas,
};